<template>
  <div>
    <section class="content-header">
      <h1>
        <span>
          {{ $ml.get('shared.realTimeMonitor') }}
          <i :style="connection == true ? 'color:green;' : 'color:red;'" class="fa fa-dot-circle-o"></i>
        </span>
        <button v-show="modules.foodMenuPopup" class="btn btn-success" style="margin-left:10px;"
          @click="changeScreen()">
          <span v-show="activeScreenStatus == 0">
            <i class="fa fa-cutlery"></i>
            {{ $ml.get('realTimeMonitor.foodMenuAndView') }}
          </span>
          <span v-show="activeScreenStatus == 1">
            <i class="fa fa-refresh"></i>
            {{ $ml.get('realTimeMonitor.entryExitList') }}
          </span>
        </button>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.realTimeMonitor') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div v-show="readerList.length > 0" class="row">
        <div class="col-sm-12">
          <div class="box box-primary collapsed-box" id="deviceControlList">
            <div @click="onCloseBoxDevice()" class="box-header with-border" style="cursor:pointer;">
              <i class="fa fa-sitemap"></i>
              <h3 class="box-title">
                <span>{{ $ml.get('realTimeMonitor.inputStatus') }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="box-body">
              <div @click="openDoorModal(reader)" v-for="reader in readerList" :key="reader.readerId"
                class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div class="detail-box" style="cursor:pointer;">
                  <span :class="customColor(reader)">
                    <img :title="getDoorStates(reader.doorStates) + ' - ' + getReaderStates(reader.connectionStatus)"
                      :src="getDoorImage(reader.doorStates)" />
                  </span>
                  <div class="info-box-content ml-80">
                    <strong class="no-wrap">
                      <span :title="reader.inputName + ' (' + reader.name + ')'" style="font-size:12px;">{{
                        reader.inputName }}</span>
                    </strong>
                    <hr style="margin-top:5px;margin-bottom:5px;" />
                    <div class="no-wrap">
                      <span class="text-muted">
                        <i class="fa fa-microchip"></i> :
                      </span>
                      <span style="font-size:12px;" :title="reader.terminalName">{{ reader.terminalName }}</span>
                    </div>
                    <div class="no-wrap">
                      <span class="text-muted">
                        <i class="fa fa-share-alt"></i> :
                      </span>
                      {{ reader.ipAddress }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4" v-show="activeScreenStatus == 0">
          <div class="box box-success">
            <div class="box-header with-border">
              <i class="fa fa-video-camera"></i>
              <h3 class="box-title">
                <span>{{ $ml.get('realTimeMonitor.lastEntry') }}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body" align="center">
              <div class="col-sm-6">
                <img class="img-rounded"
                  :src="lastEntryRecord.image ? lastEntryRecord.image : '/src/assets/default-user.png'"
                  style="width:150px;" />
              </div>
              <div class="col-sm-6">
                <div style="margin-top:10px;">
                  <span class="h4">{{ lastEntryRecord.name }}</span>
                  <br />
                  <span class="text-muted">{{ lastEntryRecord.title }}</span>
                </div>
                <h4>
                  <span>{{ lastEntryRecord.readerName }}</span>
                  <br />
                  <span class="text-muted text-primary" style="font-size:medium;">{{ lastEntryRecord.terminalGroup
                  }}</span>
                </h4>
                <h4 class="text-success">
                  <span>{{ lastEntryRecord.date }}</span>
                </h4>
              </div>
            </div>
          </div>
          <div class="box box-danger">
            <div class="box-header with-border">
              <i class="fa fa-video-camera"></i>
              <h3 class="box-title">
                <span>{{ $ml.get('realTimeMonitor.lastExit') }}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body" align="center">
              <div class="col-sm-6">
                <img class="img-rounded"
                  :src="lastExitRecord.image ? lastExitRecord.image : '/src/assets/default-user.png'"
                  style="width:150px;" />
              </div>
              <div class="col-sm-6">
                <div style="margin-top:10px;">
                  <span class="h4">{{ lastExitRecord.name }}</span>
                  <br />
                  <span class="text-muted">{{ lastExitRecord.title }}</span>
                </div>
                <h4>
                  <span>{{ lastExitRecord.readerName }}</span>
                  <br />
                  <span class="text-muted text-primary" style="font-size:medium;">{{ lastExitRecord.terminalGroup
                  }}</span>
                </h4>
                <h4 class="text-danger">
                  <span>{{ lastExitRecord.date }}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-8" v-show="activeScreenStatus == 0">
          <div class="box box-primary">
            <div class="box-header with-border" align="center">
              <h3 class="box-title">
                <span>{{ $ml.get('realTimeMonitor.entryExitList') }}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div class="table-responsive no-padding" :style="windowHeightSize">
                <table v-if="logList.length > 0" class="table table-hover"
                  style="max-height:200px;owerflow:auto;font-size:16px;">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Ad Soyad</th>
                      <th>Ünvan</th>
                      <th></th>
                      <th>Okuyucu</th>
                      <th>Zaman</th>
                      <th></th>
                      <th>Durum</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(log, index) in logList" :key="index" :class="bgAyar(log.isErrorLog, log.entryOrExit)">
                      <td>
                        <img :src="log.image ? log.image : '/src/assets/default-user.png'" style="width:50px;" />
                      </td>
                      <td style="vertical-align:middle;">{{ getCardName(log) }}</td>
                      <td style="vertical-align:middle;">{{ log.title }}</td>
                      <td style="vertical-align:middle;">{{ log.terminalGroup }}</td>
                      <td style="vertical-align:middle;">{{ log.readerName }}</td>
                      <td style="vertical-align:middle;">{{ log.date }}</td>
                      <td style="vertical-align:middle;">
                        <span v-show="log.entryOrExit == 1 && log.isErrorLog == false" class="text-success">
                          <i class="fa fa-sign-in"></i>
                        </span>
                        <span v-show="log.entryOrExit == 2 && log.isErrorLog == false" class="text-danger">
                          <i class="fa fa-sign-out"></i>
                        </span>
                        <span v-show="log.isErrorLog == true">
                          <i class="fa fa-exclamation-triangle"></i>
                        </span>
                      </td>
                      <td style="vertical-align:middle;">{{ logDescription(log.description) }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  {{ $ml.get('realTimeMonitor.logNotFoundInfo') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12" v-show="activeScreenStatus == 1">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span style="font-size:36px;">
                  <i class="fa fa-cutlery"></i>
                  {{ $ml.get('realTimeMonitor.foodMenu') }}
                </span>
              </h3>
              <h3 class="box-title pull-right">
                <span style="font-size:36px;">{{ $ml.get('realTimeMonitor.todayTotalFood') }} : {{ totalFoodCount
                }}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body" :style="windowFoodHeightSize">
              <div class="table-responsive no-padding">
                <table class="table"
                  style="max-height:200px;owerflow:auto;font-size:42px;color:black;text-align:center;margin-top:10px;">
                  <tbody>
                    <tr>
                      <td style="vertical-align:middle;border:none;">{{ foodMenus.yemek1 }}</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:middle;border:none;">{{ foodMenus.yemek2 }}</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:middle;border:none;">{{ foodMenus.yemek3 }}</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:middle;border:none;">{{ foodMenus.yemek4 }}</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:middle;border:none;">{{ foodMenus.yemek5 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--YEMEK HAREKET BİLGİ MODAL -->
      <div :class="foodLog.isErrorLog ? 'modal modal-danger fade' : 'modal modal-success fade'" id="modal-food-log"
        style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('realTimeMonitor.entryOrExitLogInfo') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row" style="margin-bottom:40px;">
                <div class="col-sm-5 text-center">
                  <img class="img-rounded" :src="foodLog.image ? foodLog.image : '/src/assets/default-user.png'"
                    style="width:150px;" />
                  <div style="margin-top:10px;">
                    <span class="h4">{{ foodLog.name }}</span>
                    <br />
                    <span>{{ foodLog.title }}</span>
                  </div>
                  <h4>
                    <span>{{ foodLog.readerName }}</span>
                    <br />
                    <span style="font-size:medium;">{{ foodLog.terminalGroup }}</span>
                  </h4>
                </div>
                <div class="col-sm-7">
                  <h4>{{ $ml.get('realTimeMonitor.logTime') }}</h4>
                  <h3 style="margin-left:30px;">{{ foodLog.date }}</h3>
                  <h4>{{ $ml.get('realTimeMonitor.logDescription') }}</h4>
                  <h3 style="margin-left:30px;">{{ foodLog.description }}</h3>
                  <h4>{{ $ml.get('realTimeMonitor.mealPay') }}</h4>
                  <h3 style="margin-left:30px;">{{ foodLog.foodPrice }} TL</h3>
                  <h4>{{ $ml.get('realTimeMonitor.availableBalance') }}</h4>
                  <h3 style="margin-left:30px;">{{ foodLog.foodRemainPrice }} TL</h3>
                </div>
              </div>
            </div>
            <!--<div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">İptal</button>
            </div>-->
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK HAREKET BİLGİ MODAL END -->
      <!--KAPI KONTROL MODAL-->
      <div class="modal modal-secondary fade" id="modal-open-door" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('realTimeMonitor.openDoor') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <h4>{{ selectedDevice.inputName }}</h4>
              <hr />
              <div class="form-group">
                <label for="relayTime">{{ $ml.get('realTimeMonitor.relayDelay') }}</label>
                <input v-model="relay" type="number" min="1" class="form-control" id="relayTime">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary w-100" @click="sendOpenDoorCommand()">
                <i class="fa fa-bolt"></i>
                {{ $ml.get('realTimeMonitor.openDoor') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--KAPI KONTROL MODAL END-->
    </section>
  </div>
</template>
<script>
import {
  HubConnectionBuilder,
  LogLevel,
  HubConnection
} from "@microsoft/signalr";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      activeScreen: 0,
      lastDate: null,
      foodMenus: {
        yemek1: "",
        yemek2: "",
        yemek3: "",
        yemek4: "",
        yemek5: ""
      },
      connection: false,
      totalFoodCount: 0,
      devices: [],
      readers: [],
      authDevice: [],
      selectedDevice: {
        name: "",
        terminalId: 0,
      },
      relay: 2,
      logs: [],
      foodLog: {
        image: null,
        name: "",
        title: "",
        terminalGroup: "",
        readerName: "",
        terminalName: "",
        date: "",
        entryOrExit: 1,
        description: "",
        isErrorLog: false,
        isFoodDevice: false,
        readerId: 0,
        foodPrice: "0",
        foodRemainPrice: "0"
      },
      lastEntryRecord: {
        image: null,
        name: "",
        title: "",
        terminalGroup: "",
        readerName: "",
        terminalName: "",
        date: "",
        entryOrExit: 1,
        description: "",
        isErrorLog: false,
        isFoodDevice: false,
        readerId: 0,
        foodPrice: "0",
        foodRemainPrice: "0"
      },
      lastExitRecord: {
        image: null,
        name: "",
        title: "",
        terminalGroup: "",
        readerName: "",
        terminalName: "",
        date: "",
        entryOrExit: 1,
        description: "",
        isErrorLog: false,
        isFoodDevice: false,
        readerId: 0,
        foodPrice: "0",
        foodRemainPrice: "0"
      }
    };
  },
  computed: {
    baseURL() {
      return this.$store.getters.getBaseURL;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowFoodHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return (
          "background-image:url('/src/assets/foodMenuBackground.jpg');background-size:cover;background-position:bottom;height:" +
          height +
          "px;overflow:auto;"
        );
      } else {
        return "background-image:url('/src/assets/foodMenuBackground.jpg');background-size:cover;background-position:bottom;height:370px;overflow:auto;";
      }
    },
    logList() {
      return this.logs;
    },
    lastExit() {
      return this.logs;
    },
    activeScreenStatus() {
      return this.activeScreen;
    },
    lastEntry() {
      return this.logs;
    },
    conStatus() {
      return this.connection;
    },
    readerList() {
      var list = this.readers.filter(a => {
        return a.inputName != "" && a.inputName != null;
      });
      return list.sort((a, b) => {
        return a.inputName
          .toUpperCase()
          .localeCompare(b.inputName.toUpperCase());
      });
    },
    deviceList() {
      return this.devices.sort((a, b) => {
        return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
      });
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.FoodMenuGetTime();
    var hubConnection = new HubConnectionBuilder()
      .withUrl(this.baseURL + "/LiveMonitor")
      .withAutomaticReconnect()
      .build();
    // connecting to the hub
    hubConnection
      .start()
      .then(() => {
        console.log("connection started");
        this.connection = true;
      })
      .catch(err => {
        console.log("connecting hub failed err is : ", err);
        this.connection = false;
      });

    hubConnection.on("NewMovement", result => {
      //console.log(result);
      let auth = this.authDevice.filter(function (device) {
        return device == result.readerId;
      });
      if (auth != "" && auth != null) {
        if (auth[0]) {
          this.logs.unshift(result);
          if (
            result.isFoodDevice == true &&
            this.activeScreenStatus == 1 &&
            this.foodLog.description != "002"
          ) {
            this.getTotalFoodCount();
            this.foodLog.image = null;
            this.foodLog.title = "";
            this.foodLog.name = "";
            this.foodLog.terminalGroup = "";
            this.foodLog.readerName = "";
            this.foodLog.date = null;
            this.foodLog.entryOrExit = 1;
            this.foodLog.description = "";
            this.foodLog.readerId = 0;
            this.foodLog.foodPrice = "0";
            this.foodLog.foodRemainPrice = "0";

            this.foodLog.image = result.image;
            this.foodLog.title = result.title;
            this.foodLog.name = this.getCardName(result);
            this.foodLog.terminalGroup = result.terminalGroup;
            this.foodLog.readerName = result.readerName;
            this.foodLog.date = result.date;
            this.foodLog.entryOrExit = result.entryOrExit;
            this.foodLog.description = this.logDescription(result.description);
            this.foodLog.isErrorLog = result.isErrorLog;
            this.foodLog.isFoodDevice = result.isFoodDevice;
            this.foodLog.readerId = result.readerId;
            this.foodLog.foodPrice = result.foodPrice;
            this.foodLog.foodRemainPrice = result.foodRemainPrice;
            $("#modal-food-log").modal("hide");
            setTimeout(function () {
              $("#modal-food-log").modal();
            }, 500);
            setTimeout(function () {
              $("#modal-food-log").modal("hide");
            }, 7000);
            //alertify.success(result.name + " - Yemek Ücreti : " + result.foodPrice + " TL - Kalan Bakiye : " + result.foodRemainPrice);
          }
          if (result.entryOrExit == 2 && result.isErrorLog == false) {
            this.lastExitRecord.image = result.image;
            this.lastExitRecord.title = result.title;
            this.lastExitRecord.name = this.getCardName(result);
            this.lastExitRecord.terminalGroup = result.terminalGroup;
            this.lastExitRecord.readerName = result.readerName;
            this.lastExitRecord.date = result.date;
            this.lastExitRecord.entryOrExit = result.entryOrExit;
            this.lastExitRecord.description = this.logDescription(
              result.description
            );
            this.lastExitRecord.isErrorLog = result.isErrorLog;
            this.lastExitRecord.isFoodDevice = result.isFoodDevice;
            this.lastExitRecord.readerId = result.readerId;
            this.lastExitRecord.foodPrice = result.foodPrice;
            this.lastExitRecord.foodRemainPrice = result.foodRemainPrice;
          } else if (result.entryOrExit == 1 && result.isErrorLog == false) {
            this.lastEntryRecord.image = result.image;
            this.lastEntryRecord.title = result.title;
            this.lastEntryRecord.name = this.getCardName(result);
            this.lastEntryRecord.terminalGroup = result.terminalGroup;
            this.lastEntryRecord.readerName = result.readerName;
            this.lastEntryRecord.date = result.date;
            this.lastEntryRecord.entryOrExit = result.entryOrExit;
            this.lastEntryRecord.description = this.logDescription(
              result.description
            );
            this.lastEntryRecord.isErrorLog = result.isErrorLog;
            this.lastEntryRecord.isFoodDevice = result.isFoodDevice;
            this.lastEntryRecord.readerId = result.readerId;
            this.lastEntryRecord.foodPrice = result.foodPrice;
            this.lastEntryRecord.foodRemainPrice = result.foodRemainPrice;
          }
        }
      }
    });
    hubConnection.on("DoorStates", result => {
      result.forEach(item => {
        let auth = this.authDevice.filter(function (device) {
          return device == item.readerId;
        });
        if (auth != "" && auth != null) {
          if (auth[0]) {
            var reader = this.readerList.filter(a => {
              return item.readerId == a.readerId;
            });
            if (reader[0]) {
              reader[0].connectionStatus = item.connectionStatus;
              reader[0].doorStates = item.lockStatus;
            }
          }
        }
      });
    });

    hubConnection.onclose(() => {
      console.log("connection failed");
      this.connection = false;
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    openDoorModal(reader) {
      this.selectedDevice = reader;
      this.relay = 2;
      $("#modal-open-door").modal();
    },
    onCloseBoxDevice() {
      $("#deviceControlList").boxWidget("toggle");
    },
    customColor(reader) {
      if (reader) {
        if (reader.connectionStatus == 0 && reader.doorStates != 1) {
          return "bg-red box-w-70";
        } else if (reader.connectionStatus == 1 && reader.doorStates != 1) {
          return "bg-green box-w-70";
        } else {
          return "bg-yellow box-w-70";
        }
      } else {
        return "box-w-70";
      }
    },
    getDoorImage(status) {
      if (status == 1) {
        return "/src/assets/open-door-black.png";
      } else {
        return "/src/assets/close-door.png";
      }
    },
    getDoorStates(status) {
      if (status == 1) {
        return this.$ml.get("general.doorOpen");
      } else {
        return this.$ml.get("general.doorIsClosed");
      }
    },
    getReaderStates(connectionStatus) {
      if (connectionStatus == 0) {
        return this.$ml.get("general.notConnected");
      } else if (connectionStatus == 1) {
        return this.$ml.get("general.connected");
      } else {
        return " - ";
      }
    },
    getShortName(name, length) {
      return name.length > length ? name.substr(0, length) + "..." : name;
    },
    logDescription(desc) {
      if (desc == "0") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.moveIn");
      } else if (desc == "1") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.entryIn");
      } else if (desc == "2") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.exitOut");
      } else if (
        desc == "101" ||
        desc == "105" ||
        desc == "302" ||
        desc == "308"
      ) {
        return (
          this.$ml.get("realTimeMonitor.movementLogDescription.noAccess") +
          " (" +
          desc +
          ")"
        );
      } else if (
        desc == "102" ||
        desc == "103" ||
        desc == "304" ||
        desc == "306"
      ) {
        return (
          this.$ml.get(
            "realTimeMonitor.movementLogDescription.dailyMealRightExpired"
          ) +
          " (" +
          desc +
          ")"
        );
      } else if (desc == "104" || desc == "307") {
        return (
          this.$ml.get(
            "realTimeMonitor.movementLogDescription.mealClaimExpired"
          ) +
          " (" +
          desc +
          ")"
        );
      } else if (desc == "301" || desc == "303" || desc == "305") {
        return (
          this.$ml.get(
            "realTimeMonitor.movementLogDescription.insufficientBalance"
          ) +
          " (" +
          desc +
          ")"
        );
      } else if (desc == "001") {
        return this.$ml.get(
          "realTimeMonitor.movementLogDescription.foodGroupNotSelected"
        );
      } else if (desc == "002") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.timeLimit");
      } else if (desc == "401") {
        return this.$ml.get(
          "realTimeMonitor.movementLogDescription.antipassback"
        );
      } else {
        return desc;
      }
    },
    getCardName(log) {
      if (log.name == "" && log.isErrorLog == true) {
        return this.$ml.get(
          "realTimeMonitor.movementLogDescription.unregisteredCard"
        );
      } else {
        return log.name;
      }
    },
    changeScreen() {
      if (this.activeScreen == 0) {
        this.activeScreen = 1;
      } else {
        this.activeScreen = 0;
      }
    },
    FoodMenuGetTime() {
      var v = this;
      setInterval(function () {
        v.getFoodMenu();
      }, 7200000);
    },
    async getTotalFoodCount() {
      await this.$axios
        .get("/FoodMenu/GetFoodCount")
        .then(response => {
          if (response.status == 200) {
            this.totalFoodCount = response.data;
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.dispatch("logout");
            }
          } else {
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoading = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoading = false;
              return;
            }
          }
        });
    },
    async getAuthDevice() {
      var authDevice = [];
      await this.$axios
        .get("/RealTimeMonitor/GetUserMonitorDevices")
        .then(response => {
          if (response.status == 200) {
            authDevice = response.data;
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.dispatch("logout");
            }
          } else {
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoading = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoading = false;
              return;
            }
          }
        });
      this.authDevice = authDevice;
    },
    async getFoodMenu() {
      this.foodMenus.yemek1 = "";
      this.foodMenus.yemek2 = "";
      this.foodMenus.yemek3 = "";
      this.foodMenus.yemek4 = "";
      this.foodMenus.yemek5 = "";
      await this.$axios
        .get("/FoodMenu")
        .then(response => {
          if (response.status == 200) {
            this.foodMenus.yemek1 = response.data.yemek1;
            this.foodMenus.yemek2 = response.data.yemek2;
            this.foodMenus.yemek3 = response.data.yemek3;
            this.foodMenus.yemek4 = response.data.yemek4;
            this.foodMenus.yemek5 = response.data.yemek5;
            this.lastDate = new Date();
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.dispatch("logout");
            }
          } else {
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoading = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoading = false;
              return;
            }
          }
        });
    },
    bgAyar(isErrorLog, entryOrExit) {
      if (isErrorLog == true) {
        return "bg-warning text-danger";
      } else {
        if (entryOrExit == 1) {
          return "bg-success";
        } else if (entryOrExit == 0) {
          return "";
        } else {
          return "bg-danger";
        }
      }
    },
    async sendOpenDoorCommand() {
      if (this.relay < 1) {
        alertify.error(this.$ml.get("realTimeMonitor.pleaseEnterRelayDelay"));
        return;
      }
      try {
        await this.$axios
          .post("/Terminal/OpenDoor", {
            terminalId: this.selectedDevice.terminalId,
            relayTime: this.relay
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("realTimeMonitor.openDoorCommandSentSuccessfully"));
              $("#modal-open-door").modal("hide");
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 400) {
                console.error(error);
                alertify.error("Servis Hatası : " + error.message);
                this.isLoadingDetail = false;
              }
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingDetail = false;
      }
    },
    async getReaders() {
      try {
        this.isLoadingDetail = true;
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            response.data.forEach(doc => {
              if (
                doc.doorType == 0 ||
                doc.doorType == 1 ||
                doc.doorType == 2 ||
                doc.doorType == 3 ||
                doc.doorType == 5
              ) {
                var device = this.devices.filter(a => {
                  return doc.terminalId == a.id;
                });
                readers.push({
                  readerNo: doc.readerNo,
                  readerId: doc.readerId,
                  terminalId: doc.terminalId,
                  terminalNo: doc.terminalNo,
                  ipAddress: doc.ipAddress,
                  inputName: doc.inputName,
                  name: doc.name,
                  terminalName: device[0] ? device[0].name : "",
                  lastConnectionTime: device[0]
                    ? device[0].lastConnectionTime
                    : " - ",
                  connectionStatus: 0, //0 bağlantı yok 1 bağlı
                  doorStates: 0 //0 belirsiz, 1 kapalı, 2 açık
                });
              }
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingDetail = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingDetail = false;
              return;
            }
          });
        this.readers = readers;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingDetail = false;
      }
    },
    async getDevices() {
      try {
        this.isLoading = true;
        const devices = [];
        const response = await this.$axios
          .get("/Terminal")
          .then(response => {
            response.data.forEach(doc => {
              devices.push({
                id: doc.id,
                no: doc.no,
                name: doc.name,
                ip: doc.ip,
                lastConnectionTime: doc.lastConnectionTime,
                lastConnectionStatus: doc.lastConnectionStatus
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.devices = devices;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthDevice();
    await this.getDevices();
    await this.getReaders();
    await this.getTotalFoodCount();
    if (this.modules.foodMenuPopup) {
      await this.getFoodMenu();
    }
    $("body").addClass("sidebar-collapse");
  }
};
</script>

<style scoped>
.ml-80 {
  margin-left: 60px;
}

.box-w-70 {
  width: 60px;
  height: 90px;
  border-top-left-radius: 2px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 2px;
  display: block;
  float: left;
  text-align: center;
  line-height: 80px;
  background: rgba(0, 0, 0, 0.2);
}

.box-w-70 img {
  width: 50px;
}

.detail-box {
  display: block;
  min-height: 90px;
  background: #fff;
  width: 100%;
  box-shadow: 0 1px 1px rgb(0 0 0 / 10%);
  border-radius: 2px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/realTimeMonitor/RealTimeMonitor.vue